export default __webpack_public_path__ + "static/media/021-chicken.3974c154.svg";